<template>
  <div id="footer" class="align-start">
    <v-row id="footer-content" class="mt-3 mb-16 mb-md-0 pa-0" no-gutters>
      <v-col cols="12">
        <v-row class="pa-0 pb-4 mt-2 mb-1">
          <template v-if="!hideTerms && !hideTermsForRoute">
            <v-col class="text-center pa-0" cols="0" md="3"></v-col>
            <v-col
              v-if="termsConditionsEnabled"
              class="text-center px-md-0 py-0"
              cols="6"
              md="3"
            >
              <router-link :to="{ name: 'terms-conditions' }"
                >Terms & Conditions</router-link
              >
            </v-col>
            <v-col
              v-if="privacyPolicyEnabled"
              class="text-center px-md-0 py-0"
              cols="6"
              md="3"
            >
              <router-link :to="{ name: 'privacy-policy' }"
                >Privacy Policy</router-link
              >
            </v-col>
            <v-col class="text-center pa-0" cols="0" md="3"></v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row class="pa-0 mt-2">
          <v-col class="text-center pa-0">
            <p
              v-if="isAuthenticated"
              id="footer-tag-line"
              v-html="footerTagLine"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    hideTerms: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('tenant', [
      'footerTagLine',
      'termsConditionsEnabled',
      'privacyPolicyEnabled'
    ]),

    hideTermsForRoute() {
      return this.$route.meta?.hideTerms
    }
  }
}
</script>

<style lang="scss" scoped>
#footer {
  background: $primary-color;
  padding-top: 12px;
  padding-bottom: 32px;

  #footer-content {
    margin-left: 24px;
    margin-right: 24px;
    max-width: $page-max-width-mobile;
    overflow-x: hidden;

    a:link,
    a:visited,
    a:hover,
    a:active {
      color: white !important;
      text-decoration: none !important;
    }

    link {
      color: white;
    }

    .text-center p {
      color: white;
      opacity: 0.5;
      font-size: 18px;
    }

    #footer-tag-line {
      font-size: 0.9em;
    }
  }
}

@media only screen and (min-width: 630px) {
  #footer {
    #footer-content {
      margin-left: auto;
      margin-right: auto;
    }
  }
}

@media only screen and (min-width: 960px) {
  #footer {
    #footer-content {
      max-width: $page-max-width-desktop;
    }
  }
}
</style>
